export const pliTemplate = ({ fileName, numberOfrows, rows }) =>
  `${fileName}\n\t${numberOfrows}\t2\n${rows}
`;
